import React from 'react';

import propTypes from 'prop-types';

import MeetingPasswordView from '../MeetingPasswordView';

import ExternalVideoComponent from '../ExternalVideoComponent';

class MeetingStartedView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.statusInterval = null;
  }

  componentDidMount() {
    this.pollRecordingStatus();
    // Poll recording status every 3 seconds to drive UI state
    this.statusInterval = setInterval(this.pollRecordingStatus, 3000);
  }

  componentWillUnmount() {
    if (this.statusInterval) {
      clearInterval(this.statusInterval);
    }
  }

  pollRecordingStatus = () => {
    const { getRecordingStatus, meetingId } = this.props;
    if (meetingId) {
      getRecordingStatus(meetingId);
    }
  }

  render() {
    const {
      isPasswordAccessEnabled,
      isModerator,
      isPasswordVerified,
      history,
      match,
    } = this.props;

    return (
      <div>
        {
          isPasswordAccessEnabled && !isModerator && !isPasswordVerified ?
            <div>
              <MeetingPasswordView
                history={history}
                match={match}
              />
            </div>
            :
            <div>
              <ExternalVideoComponent
                history={history}
                match={match}
              />
            </div>
        }
      </div>
    );
  }

}

MeetingStartedView.propTypes = {
  isPasswordAccessEnabled: propTypes.bool,
  isModerator: propTypes.bool,
  isPasswordVerified: propTypes.bool,
  history: propTypes.object,
  isPasswordVerified: propTypes.bool,
  history: propTypes.object,
  match: propTypes.object,
  getRecordingStatus: propTypes.func,
  meetingId: propTypes.string,
};

MeetingStartedView.defaultProps = {
  isPasswordAccessEnabled: false,
  isModerator: false,
  isPasswordVerified: false,
};


export default MeetingStartedView;
